<section class="bg-base-100 flex select-none rounded-md p-3">
  <ng-container *ngTemplateOutlet="yearSection" />
  <div class="flex w-full flex-col border-l border-base-content/5 pl-4">
    <ng-container *ngTemplateOutlet="header" />
    <ng-container *ngTemplateOutlet="daySection" />
  </div>
</section>

<ng-template #header>
  <section class="relative mb-2 flex w-full items-center justify-between">
    <p class="text-sm font-semibold text-base-content">
      {{ currentDate() | date: 'y년 MM월' }}
    </p>

    <div class="flex items-center gap-1">
      <button (click)="handleNavigate('prev', 'month', 1)" class="btn btn-ghost btn-xs btn-square">
        <span class="icon-[mdi--chevron-left] text-base"></span>
      </button>
      <button (click)="handleNavigate('next', 'month', 1)" class="btn btn-ghost btn-xs btn-square">
        <span class="icon-[mdi--chevron-right] text-base"></span>
      </button>
    </div>
  </section>
</ng-template>

<ng-template #yearSection>
  <section class="flex flex-col gap-2 pr-4">
    <p class="text-xs font-semibold text-base-content/60 uppercase tracking-wider">년도</p>
    <div id="carousel" class="year-section relative flex max-h-64 min-w-32 flex-col overflow-y-auto">
      @for (y of years(); track $index) {
        <button
          (click)="handleSelectYear(y)"
          [id]="y"
          class="cursor-pointer rounded-md px-2 py-1.5 text-sm transition-colors"
          [ngClass]="
            y === year() ? 'bg-primary/10 text-primary font-semibold' : 'text-base-content/70 hover:bg-base-200'
          ">
          {{ y }}
        </button>
      }
    </div>
  </section>
</ng-template>

<ng-template #daySection>
  <section class="flex w-full flex-col">
    <div class="grid w-full grid-cols-7 mb-1">
      <p class="item text-xs font-medium text-error/70">일</p>
      <p class="item text-xs font-medium text-base-content/50">월</p>
      <p class="item text-xs font-medium text-base-content/50">화</p>
      <p class="item text-xs font-medium text-base-content/50">수</p>
      <p class="item text-xs font-medium text-base-content/50">목</p>
      <p class="item text-xs font-medium text-base-content/50">금</p>
      <p class="item text-xs font-medium text-info/70">토</p>
    </div>
    <div class="grid w-full grid-cols-7">
      @for (dayItem of days(); track $index) {
        <lepi-day
          [day]="dayItem"
          [viewDate]="currentDate()"
          [isStart]="isStart(dayItem)"
          [isEnd]="isEnd(dayItem)"
          [isInRange]="isInRange(dayItem)"
          (daySelect)="handleSelectDay(dayItem)" />
      }
    </div>
  </section>
</ng-template>
